(function () {
  "use strict";

  var TIMEOUT_MS = 12000;
  var POLL_INTERVAL_MS = 300;
  var REGATE_POLL_INTERVAL_MS = 1000;
  var REDIRECT_TO_GOKWIK_ON_SUPPRESS = false;

  function readKillSwitch() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("zk_cart_gate") === "off") return true;
    } catch (e) {}
    try {
      if (window.localStorage && window.localStorage.getItem("zk_cart_gate") === "off") return true;
    } catch (e) {}
    return false;
  }

  function isDebug() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("zk_cart_gate") === "debug";
    } catch (e) {
      return false;
    }
  }

  var debug = isDebug();
  var startTime = Date.now();

  var state = {
    gated: false,
    releaseReason: null,
    readinessObserved: false,
    reGated: false,
    kwikCartActive: undefined
  };

  function log() {
    if (!debug) return;
    try {
      console.log.apply(console, ["[cart-drawer-gate]"].concat(Array.prototype.slice.call(arguments)));
    } catch (e) {}
  }

  function getShadowRoot() {
    var container = document.querySelector("shadow-dom-container");
    return container ? container.shadowRoot : null;
  }

  function gokwikReady() {
    var sr = getShadowRoot();
    if (!sr) return false;
    if (!sr.querySelector('style[id^="svelte-"]')) return false;
    return typeof window.openGokwikSideCart === "function";
  }

  function sidecartMounted() {
    var sr = getShadowRoot();
    if (!sr) return false;
    return !!sr.querySelector(".sidecart");
  }

  function captureKwikCartActive() {
    state.kwikCartActive = window.kwikCartActive;
  }

  window.__zkCartGate = {
    status: function () {
      return {
        state: state.gated ? "gated" : "released",
        releaseReason: state.releaseReason,
        readinessObserved: state.readinessObserved,
        reGated: state.reGated,
        elapsedMs: Date.now() - startTime,
        kwikCartActive: state.kwikCartActive
      };
    }
  };

  if (readKillSwitch()) {
    state.gated = false;
    state.releaseReason = "killswitch";
    log("kill switch active, gate not installed");
    return;
  }

  var installFlagProp = "__zkCartGateInstalled";

  function installGate(Ctor) {
    if (Ctor[installFlagProp]) return;
    Ctor[installFlagProp] = true;

    var originalShow = Ctor.prototype.show;
    var timeoutId = null;
    var pollId = null;
    var regatePollId = null;
    var observer = null;
    var locked = false;

    function gatedShow() {
      if (state.gated) {
        return Promise.resolve();
      }
      // FIX: the gate can be in "released" state (timeout fired with no readiness signal yet)
      // while Gokwik has actually finished loading moments later, before the next 300ms/1s poll
      // catches up. Without this live re-check, the native drawer would open for real right here,
      // then get closed almost instantly when Gokwik's own openGokwikSideCart() mounts its
      // side-cart UI outside <cart-drawer> — which the drawer's own "click outside closes it"
      // focus-trap treats as an outside interaction. Checking readiness live, at the exact moment
      // show() is called, closes that race instead of relying only on the periodic poll.
      if (gokwikReady()) {
        if (!locked) onReadinessConfirmed();
        return Promise.resolve();
      }
      return originalShow.apply(this, arguments);
    }

    function teardownTimers() {
      if (timeoutId !== null) { clearTimeout(timeoutId); timeoutId = null; }
      if (pollId !== null) { clearInterval(pollId); pollId = null; }
      if (regatePollId !== null) { clearInterval(regatePollId); regatePollId = null; }
      if (observer) { observer.disconnect(); observer = null; }
    }

    function lockGated() {
      locked = true;
      teardownTimers();
    }

    window.__zkCartGate.forceRelease = function () {
      if (Ctor.prototype.show === gatedShow) Ctor.prototype.show = originalShow;
      state.gated = false;
      if (!state.releaseReason) state.releaseReason = "forced";
      lockGated();
    };

    function onReadinessConfirmed() {
      if (locked) return;
      state.readinessObserved = true;
      captureKwikCartActive();
      log("readiness observed, gate remains on for page lifetime");
      lockGated();
    }

    function poll() {
      if (locked) return;
      if (gokwikReady()) onReadinessConfirmed();
    }

    function reapplyGate(reason) {
      if (locked) return;
      Ctor.prototype.show = gatedShow;
      state.gated = true;
      state.reGated = true;
      state.releaseReason = null;
      state.readinessObserved = true;
      captureKwikCartActive();
      log("re-gated after release, reason:", reason);
      lockGated();
    }

    function startPostReleaseWatch() {
      var sr = getShadowRoot();
      if (sr) {
        try {
          observer = new MutationObserver(function () {
            if (sidecartMounted()) reapplyGate("sidecart-observed");
          });
          observer.observe(sr, { childList: true, subtree: true });
        } catch (e) {}
      }
      regatePollId = setInterval(function () {
        if (locked) return;
        if (gokwikReady() || sidecartMounted()) reapplyGate("post-timeout-poll");
      }, REGATE_POLL_INTERVAL_MS);
    }

    Ctor.prototype.show = gatedShow;
    state.gated = true;
    captureKwikCartActive();
    log("gate installed, native show() suppressed");

    try {
      window.addEventListener("gokwikLoaded", function () {
        log("gokwikLoaded event observed (hint only), polling immediately");
        poll();
      }, { once: true });
    } catch (e) {}

    pollId = setInterval(poll, POLL_INTERVAL_MS);
    poll();

    timeoutId = setTimeout(function () {
      if (state.readinessObserved || locked) return;
      Ctor.prototype.show = originalShow;
      state.gated = false;
      state.releaseReason = "timeout";
      captureKwikCartActive();
      if (pollId !== null) { clearInterval(pollId); pollId = null; }
      log("gate released, reason: timeout — entering self-healing watch");
      startPostReleaseWatch();
    }, TIMEOUT_MS);
  }

  if (typeof window.customElements === "undefined" || typeof window.customElements.whenDefined !== "function") {
    return;
  }

  window.customElements.whenDefined("cart-drawer").then(function () {
    var Ctor = window.customElements.get("cart-drawer");
    if (Ctor) installGate(Ctor);
  });
})();